import React from "react"
import { useTranslation } from "react-i18next"

import SingleAuthor from './single-author'

import {
  makeStyles,
  Container,
  Grid,
  Box,
  Button,
} from "@material-ui/core"
import SEO from "./seo"

const useStyles = makeStyles(theme => ({
  cardGrid: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  loadmoreBtnWrap: {
    marginTop: theme.spacing(1),
    textAlign: "center",
  },
}))

export default function AuthorsList({ props, authors }) {
  const classes = useStyles()
  const [t, i18n] = useTranslation()
  const [loadedPublishers, setloadedPublishers] = React.useState(8)

  const handleLoadMore = () => {
    setloadedPublishers(loadedPublishers + 8)
  }

  return (
    <Container className={classes.cardGrid} maxWidth="lg">
      <SEO title="Publishers list" lang={i18n.language} />
      <Grid container spacing={4}>
        {authors.slice(0, loadedPublishers).map((item, key) => (
          <SingleAuthor authors={item} key={key} />
        ))}
      </Grid>
      {authors.length > loadedPublishers && (
        <Box className={classes.loadmoreBtnWrap} p={2}>
          <Button variant="outlined" color="primary" onClick={handleLoadMore}>
            {t("bookList.loadMoreBtn")}
          </Button>
        </Box>
      )}
    </Container>
  );
}